import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  getAddressByMacApi,
  createUserAddressMacApi,
} from "../../_App/Redux/Slices/userMacAdress/userAddressMacSlice";
import {
  changeOrganisationselected,
  SelectedOrganisationId,
  selectUser,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { UserMacAdressDataType } from "../../_App/Types/Forms/UserMacAdressDataType";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { useTranslation } from "react-i18next";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../_App/Redux/Slices/organisations/organisationSlice";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getMachineId } from "../../_App/Helpers/helpers";

const Container = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: bold;
  margin-right: 8px;
  white-space: nowrap;
  width: 120px;
`;

const Input = styled.input`
  width: 200px; /* Vous pouvez ajuster la largeur selon vos besoins */
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;
const Select = styled.select`
  width: 200px; /* Vous pouvez ajuster la largeur selon vos besoins */
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #999;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const MacAddressComponent: React.FC<{
  onClosePopup: (success: boolean) => void;
  setShowPinModal: any;
}> = ({ onClosePopup, setShowPinModal }) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectUser);
  const user_id = currentUser?._id;

  const [mounted, setMounted] = useState(false);
  const [codeBarre, setCodeBarre] = useState("");
  const [codeCaisse, setCodeCaisse] = useState("");
  const [libelle, setLibelle] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [organisation_id, setorgaisation_id] = useState<any>();
  const [browserId, setBrowserId] = useState<string>(""); // <-- nouvel état pour fingerprint
  const societeid = useAppSelector(societeId);
  const { t } = useTranslation();
  const listOrganisation = useAppSelector(ListOrganisations);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);

  // --- récupérer fingerprint à l'initialisation ---

  useEffect(() => {
    if (societeid) {
      dispatch(allOrganisationsApi(societeid));
    }
  }, [societeid]);

  useEffect(() => {
    setorgaisation_id(listOrganisation[0]);
  }, [listOrganisation]);

  const handleAddMacAddress = async () => {
    if (organisation_id && codeCaisse) {
      const id_Machine = getMachineId(organisation_id);

      const userMacAddress: UserMacAdressDataType = {
        mac_address: id_Machine,
        code_a_barre: codeBarre,
        code_caisse: codeCaisse,
        libelle: libelle,
        user_id: user_id,
        organisation_id,
      };

      try {
        const response = await dispatch(
          createUserAddressMacApi(userMacAddress)
        );

        if (response.payload.success) {
          localStorage.setItem("idmachine", id_Machine);

          const findOrganisation = listOrganisation.find(
            (org) => org._id === organisation_id
          );
          await dispatch(
            changeOrganisationselected({
              organisations: findOrganisation,
            })
          );

          ToastSuccess(response.payload.message);
          setShowPinModal(true);
          setFormValid(true);
          onClosePopup(true);
        } else {
          ToastWarning("L'adresse MAC existe déjà !");
          setFormValid(false);
          onClosePopup(false);
        }
      } catch (error) {
        ToastWarning("Une erreur s'est produite lors de l'appel API.");
        setFormValid(false);
        onClosePopup(false);
      }
    } else {
      ToastWarning("Veuillez remplir tous les champs obligatoires.");
      setFormValid(false);
    }
  };

  return (
    <Container>
      {" "}
      <InputContainer>
        {" "}
        <Label>{t("Code Caisse:")} *</Label>{" "}
        <Input
          type="text"
          value={codeCaisse}
          onChange={(e) => setCodeCaisse(e.target.value)}
          required
        />{" "}
      </InputContainer>{" "}
      <InputContainer>
        {" "}
        <Label>{t("Libellé")} :</Label>{" "}
        <Input
          type="text"
          value={libelle}
          onChange={(e) => setLibelle(e.target.value)}
        />{" "}
      </InputContainer>{" "}
      <InputContainer>
        {" "}
        <Label>{t("Code à Barre")}:</Label>{" "}
        <Input
          type="text"
          value={codeBarre}
          onChange={(e) => setCodeBarre(e.target.value)}
        />{" "}
      </InputContainer>{" "}
      <InputContainer>
        {" "}
        <Label>{t("Organisation")}:</Label>{" "}
        <Select onChange={(e) => setorgaisation_id(e.target.value)}>
          {" "}
          {listOrganisation.map((i) => (
            <option value={i._id} key={i._id}>
              {" "}
              {i.nom}{" "}
            </option>
          ))}{" "}
        </Select>{" "}
      </InputContainer>{" "}
      <div>
        {" "}
        <ButtonContainer>
          {" "}
          <button onClick={handleAddMacAddress} className="btn btn-primary-app">
            {" "}
            {t("Enregistrer")} <i className="fas fa-check"></i>{" "}
          </button>{" "}
        </ButtonContainer>{" "}
      </div>{" "}
    </Container>
  );
};

export default MacAddressComponent;
